import { render, staticRenderFns } from "./iconSettings.vue?vue&type=template&id=3fbd082c&scoped=true"
import script from "./iconSettings.vue?vue&type=script&lang=js"
export * from "./iconSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd082c",
  null
  
)

export default component.exports